import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { checkedListEmptyMsg, dataNotFoundMsg, noInternetMsg, saveFailedMsg, savemsg, saveWarningMsg, serverMsg } from "../../config/messageconstant";
import { mandatoryCheck } from "../../config/ValidationCheck";
import { holidayStructureAssignationJson } from "../../DynamicFormsJson/Transaction/holidayStrctureAssigantion";
import {
    getHolidayStructureActiveGetAll,
    getSalesTeamWhoDoesNotHaveHolidayStructure,
    setSalesTeamWhoDoesNotHaveHolidayStructure
} from "../../Slice/year.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import HolidayStructureAssignationFormTable from "./HolidayStructureAssignationFormTable";

class HolidayStructureAssignationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                holidayStructureDetail: this.props.holidayList?.holidayStructure,
            },
            formErrors: {},
            fieldData: {},
            allChecked: false,
        }
    }

    async componentDidMount() {
        const { setSalesTeamWhoDoesNotHaveHolidayStructure, getHolidayStructureActiveGetAll, showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            setSalesTeamWhoDoesNotHaveHolidayStructure({ row: [] });

            showLoador({ loador: true });
            await getHolidayStructureActiveGetAll().then(({ response, success }) => {
                if (!success) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                }
            });
            showLoador({ loador: false });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }


    componentWillReceiveProps(nextProps) {
        if (
            this.props.holidayList.holidayStructure !==
            nextProps.holidayList.holidayStructure
        ) {
            this.setState({
                dynamicMasterData: {
                    ...this.state.dynamicMasterData,
                    holidayStructureDetail: nextProps.holidayList.holidayStructure,
                },
            });
        }
    }


    getListById = async (data) => {
        const {
            getSalesTeamWhoDoesNotHaveHolidayStructure,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {

            if (data.holidayStructureHeader && data.holidayStructureHeader != "") {
                showLoador({ loador: true });
                await getSalesTeamWhoDoesNotHaveHolidayStructure({
                    holidayStructureHeaderId: data.holidayStructureHeader
                }).then(
                    ({ response, success }) => {
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        } else {
                            if (response.length == 0) {
                                return showNotification({ msg: dataNotFoundMsg, severity: "error" });
                            }
                        }
                    }
                );
                showLoador({ loador: false });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: holidayStructureAssignationJson.fieldMeta,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        return mandatoryCheckErrors.formValid;
    };

    submithandler = () => {
        const { holidayList, showNotification } = this.props;
        const { fieldData } = this.state;
        const salesTeamIds =
            holidayList?.holidayStructureForSalesTeam
                .filter((row) => row.isChecked).map((dataObj) => dataObj.id);
        const dataToSave = {
            salesTeamIds: salesTeamIds
        }
        if (salesTeamIds.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }
        if (this.checkValidationOnSubmit()) {
            this.onSave(dataToSave, fieldData?.holidayStructureHeader);
        }
    }

    onSave = (dataToSave, holidayStructureHeader) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            swal({
                title: "Are you sure?",
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url: endpoint.holidayStructureAssignation
                            + "/save-list?holidayStructureHeaderId=" + holidayStructureHeader,
                        postBody: dataToSave,
                    }).then(({ data, success }) => {
                        if (success) {
                            this.props.navigate(-1);
                            showNotification({ msg: savemsg });
                        } else {
                            showNotification({ msg: saveFailedMsg, severity: "error" });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;
        holidayStructureAssignationJson.fieldMeta.map((currentField) => {
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");

                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });

                this.getListById(dataToSearch);
            }
            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };


    handleAllCheckedClick = (e) => {
        const { setSalesTeamWhoDoesNotHaveHolidayStructure, holidayList } = this.props;
        this.setState({ allChecked: e.target.checked });
        let dataList = holidayList?.holidayStructureForSalesTeam.map((dataObj) => {
            return {
                ...dataObj,
                isChecked: e.target.checked,
            };
        });
        setSalesTeamWhoDoesNotHaveHolidayStructure({ row: dataList })
    };


    handleCheckBoxClick = (e, id) => {
        const { setSalesTeamWhoDoesNotHaveHolidayStructure, holidayList } = this.props;
        let dataListForSingleCheckBoxSelection = holidayList?.holidayStructureForSalesTeam.map((dataObj) => {
            if (dataObj.id == id) {
                return {
                    ...dataObj,
                    isChecked: e.target.checked,
                };
            } else {
                return dataObj;
            }
        });
        setSalesTeamWhoDoesNotHaveHolidayStructure({ row: dataListForSingleCheckBoxSelection })
    };


    render() {
        const {
            fieldData,
            formErrors,
            dynamicMasterData,
            allChecked,
        } = this.state;

        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        getListById={this.getListById}
                        showTitle={holidayStructureAssignationJson.showTitle}
                        screenTitle={holidayStructureAssignationJson.screenTitle}
                        fieldMeta={holidayStructureAssignationJson.fieldMeta}
                        apiBaseURL={holidayStructureAssignationJson.apiBaseURL}
                        formErrors={formErrors}
                        showSaveBtn={holidayStructureAssignationJson.showSaveBtn}
                        showSaveBtnMain={false}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        showBackToList={true}
                    />

                    <HolidayStructureAssignationFormTable
                        clickSubmitHandler={this.submithandler}
                        allChecked={allChecked}
                        handleAllCheckedClick={this.handleAllCheckedClick}
                        handleCheckBoxClick={this.handleCheckBoxClick}
                        salesTeamDataList={this.props.holidayList?.holidayStructureForSalesTeam}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    holidayList: state.year,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getHolidayStructureActiveGetAll,
    getSalesTeamWhoDoesNotHaveHolidayStructure,
    setSalesTeamWhoDoesNotHaveHolidayStructure,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(HolidayStructureAssignationForm);
